import { useState, type FormEvent } from 'react';

const formSubmitAddr = 'http://aywxtna.cn/';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    try {
      formData.delete('website_alt');
      const response = await fetch(formSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！每日最新吃瓜资讯将发送到您的邮箱。');
        setEmail('');
      } else if (serverMsg.includes('spam')) {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后重试。');
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-foreground-950">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-3">
          不想错过任何爆料？
        </h2>
        <p className="text-sm text-foreground-300 mb-8 max-w-lg mx-auto">
          订阅每日吃瓜推送，最新网红塌房、独家黑料第一时间送达您的邮箱。
        </p>
        <form
          onSubmit={handleSubmit}
         
          id="newsletter-form"
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-4 py-2.5 rounded-md bg-foreground-900 border border-foreground-700 text-white text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="absolute left-[-9999px] opacity-0 pointer-events-none h-0 w-0 overflow-hidden"
          />
          <button
            type="submit"
            className="px-6 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>
        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}